import { Month, Year } from '@leadgen/models/client'

class DateFormatter {
  formatDisplayDate = (dateIn: string | Date) => {
    const date = new Date(dateIn)
    const day = date.getDate()
    const formattedDate = new Intl.DateTimeFormat('en-GB', {
      day: 'numeric', // '17'
      month: 'short', // 'Sep'
      year: 'numeric', // '2025'
    }).format(date)
    return formattedDate.replace(day.toString(), `${day}${this.getDaySuffix(day)}`)
  }
  formatDisplayTimestamp = (dateIn: string | Date) => {
    const date = new Date(dateIn)
    const day = date.getDate()
    const formattedDate = new Intl.DateTimeFormat('en-GB', {
      day: 'numeric', // '17'
      month: 'short', // 'Sep'
      year: 'numeric', // '2025'
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(date)
    return formattedDate.replace(day.toString(), `${day}${this.getDaySuffix(day)}`)
  }
  formatYearMonth = (date: Date = new Date()) => {
    return `${this.formatYear(date)}/${this.formatMonth(date)}` as `${Year}/${Month}`
  }
  private formatMonth = (date: Date = new Date()) => {
    const monthFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      month: '2-digit',
    })
    const month = monthFormatter.format(date) as Month
    return month
  }
  private formatYear = (date: Date = new Date()) => {
    const yearFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric',
    })
    const year = yearFormatter.format(date) as Year
    return year
  }
  private getDaySuffix = (day: number) => {
    if (day >= 11 && day <= 13) return 'th'
    switch (day % 10) {
      case 1:
        return 'st'
      case 2:
        return 'nd'
      case 3:
        return 'rd'
      default:
        return 'th'
    }
  }
}

export default new DateFormatter()
